import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setModal } from "../../../../actions/index";

import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';

let lock = false;
const useNoConnected = () => {
  const dispatch = useDispatch();
  const enable = useSelector( state => state.enablePM );
  const user = useSelector( state => state.user);
  const storeAuth = useSelector( state => state.storeAuth );

  useEffect(() => {
    const roomInvitation = JSON.parse(localStorage.getItem('invit_pm'));
    const alreadyInRoom = localStorage.getItem('a5RAW%93W!gph8');
    const expired = (localStorage.getItem('expired')) ? localStorage.getItem('expired').toString().includes(`1987`) : true;
    if (!enable && !user && (roomInvitation || alreadyInRoom) && expired && !lock) { // Invitation - No Connected
      lock = true;
      if (roomInvitation && roomInvitation.active) {
        dispatch(setModal({
          content: (
            <ModalCTA
              id={`no-connected-invitation`}
              title={`You’re invited to DJ.`}
              description={`‘${roomInvitation.owner}’ invited you to join their set.`}
              styleContainer={{marginTop: `-40%`, marginLeft: `-10%`}}
              classModal={`bottom-reduce`}
              styleBody={{gap: 26}}
              ctaFlexDirection={`flexRow`}
            >
              <ModalButton label={`Sign up`} className={`primary half`} onClick={storeAuth.registration} autoCancel={false} />
              <ModalButton label={`Log in`} className={`transparent-grey half`} onClick={storeAuth.signin} autoCancel={false} />
              <ModalButton label={`No thanks`} className={`cancel`} />
            </ModalCTA>
          )
        }));
      }
   }
 }, [enable, user, dispatch, storeAuth])

  return null;
};

export default useNoConnected;
